import { useTranslation } from "react-i18next";

import styles from "./styles";

import Grid from "@mui/material/Grid";

import { HeadTitle, WhiteSpace } from "../";

const ClientsGrid = () => {
  const { t: translation } = useTranslation("home");

  const data = [
    {
      title: translation("clientsGrid.companies.title"),
      content: translation("clientsGrid.companies.content"),
    },
    {
      title: translation("clientsGrid.students.title"),
      content: translation("clientsGrid.students.content"),
    },
    {
      title: translation("clientsGrid.shops.title"),
      content: translation("clientsGrid.shops.content"),
    },
    {
      title: translation("clientsGrid.solopreneurs.title"),
      content: translation("clientsGrid.solopreneurs.content"),
    },
    {
      title: translation("clientsGrid.restaurants.title"),
      content: translation("clientsGrid.restaurants.content"),
    },
    {
      title: translation("clientsGrid.freelancers.title"),
      content: translation("clientsGrid.freelancers.content"),
    },
    {
      title: translation("clientsGrid.startups.title"),
      content: translation("clientsGrid.startups.content"),
    },
    {
      title: translation("clientsGrid.professionals.title"),
      content: translation("clientsGrid.professionals.content"),
    },
  ];

  return (
    <Grid container style={styles.container}>
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          key={index}
          style={styles.gridItem}
        >
          <div style={styles.div}>
            <HeadTitle variant="h3" title={item.title} />
            <WhiteSpace height="10px" />
            <HeadTitle
              variant="h4"
              title={item.content}
              style={styles.content}
            />
            <WhiteSpace height="20px" />
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default ClientsGrid;
